import React, { useState } from 'react';
import { ChevronRight, Loader2, Search } from 'lucide-react';
import { Button } from '../../Button';
import { MobileHeader } from '../MobileHeader';
import { MobileBottomNav } from '../MobileBottomNav';
import { StatusBadge } from '../../common/StatusBadge';
import type { MobileNav } from '../../../types/mobile';
const index = [{
  reg: 'ঢাকা-থ-১১-১২৩৪',
  qr: 'CNG-000001',
  owner: 'মোঃ রহিম উদ্দিন',
  valid: true
}, {
  reg: 'ঢাকা-থ-১৩-৭৮৯০',
  qr: 'CNG-000004',
  owner: 'মোসাঃ শাহনাজ বেগম',
  valid: false
}];
export function SearchScreen({
  nav
}: {
  nav: MobileNav;
}) {
  const [q, setQ] = useState('১১-১২৩৪');
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<typeof index | null>(null);
  const run = (e?: React.FormEvent) => {
    e?.preventDefault();
    setLoading(true);
    window.setTimeout(() => {
      const term = q.trim();
      setResults(index.filter(i => i.reg.includes(term) || i.qr.toLowerCase().includes(term.toLowerCase())));
      setLoading(false);
    }, 600);
  };
  return <div className="flex h-full flex-col bg-slate-50" data-id="element-589" data-mp="35xrp9sg7b70e">
      <MobileHeader title="গাড়ির নম্বর দিয়ে খুঁজুন" data-id="element-590" data-mp="31x7nucolhh8g" />
      <form onSubmit={run} className="space-y-2 border-b border-border bg-white p-4" data-id="element-591" data-mp="2wz68a1qdo01q">
        <p className="text-xs text-slate-500" data-id="element-592" data-mp="2x10urkhas07x">রেজিস্ট্রেশন নম্বর অথবা QR ID লিখুন</p>
        <div className="flex items-center gap-2 rounded-lg border-2 border-navy-200 px-3 py-2.5 focus-within:border-navy-600" data-id="element-593" data-mp="2s1xmlr60tdvq">
          <span className="rounded bg-navy-50 px-1.5 py-0.5 text-xs font-semibold text-navy-800" data-id="element-594" data-mp="3kos3ke3mpv4g">ঢাকা-থ</span>
          <input value={q} onChange={e => setQ(e.target.value)} className="flex-1 bg-transparent text-base font-semibold outline-none" aria-label="গাড়ির নম্বর" data-id="element-595" data-mp="3fxsaxl1jlz7r" />
        </div>
        <div className="flex flex-wrap gap-1.5" data-id="element-596" data-mp="3ax4icuxo1abf">
          {['১১-১২৩৪', '১৩-৭৮৯০', 'CNG-000001'].map(s => <button type="button" key={s} onClick={() => setQ(s)} className="rounded-full border border-border px-2.5 py-1 text-[11px] text-slate-600" data-id="element-597" data-mp="7iibylsy9a47">{s}</button>)}
        </div>
        <Button type="submit" className="h-11 w-full" disabled={loading} data-id="element-598" data-mp="21sgia33yxv1k">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" data-id="element-599" data-mp="25ts6c477287n" /> : <Search className="h-4 w-4" data-id="element-600" data-mp="1s12ma5b87dd6" />} খুঁজুন
        </Button>
      </form>
      <div className="no-scrollbar flex-1 space-y-2 overflow-y-auto p-4" data-id="element-601" data-mp="1wz446mwx16n2">
        {results === null && <p className="pt-6 text-center text-sm text-slate-400" data-id="element-602" data-mp="1i23boh6wh7nj">স্টিকার পড়া না গেলে নম্বর দিয়ে যাচাই করুন</p>}
        {results?.length === 0 && <div className="rounded-xl border border-dashed border-red-300 bg-red-50 p-5 text-center text-sm text-red-700" data-id="element-603" data-mp="1n294w1stj27q">ডিএমপি সিস্টেমে কোনো রেকর্ড পাওয়া যায়নি</div>}
        {results?.map(r => <button key={r.qr} onClick={() => {
        nav.setScenario(r.valid ? 'valid' : 'invalid');
        nav.go(r.valid ? 'result' : 'invalid');
      }} className="flex w-full items-center gap-3 rounded-xl border border-border bg-white p-3.5 text-left" data-id="element-604" data-mp="1e1jddaalbxzt">
            <div className="flex-1" data-id="element-605" data-mp="3iipoaoq6cucl">
              <p className="font-bold text-navy-900" data-id="element-606" data-mp="3djms7ts69ygr">{r.reg}</p>
              <p className="text-xs text-slate-500" data-id="element-607" data-mp="3dl7mrjehlhem">{r.owner} • <span className="font-mono" data-id="element-608" data-mp="3rbb5w1i2kuzu">{r.qr}</span></p>
            </div>
            <StatusBadge tone={r.valid ? 'green' : 'red'} data-id="element-609" data-mp="3mk2vp38x15lm">{r.valid ? 'বৈধ' : 'সমস্যা'}</StatusBadge>
            <ChevronRight className="h-4 w-4 text-slate-400" data-id="element-610" data-mp="53kwhge8x5lc" />
          </button>)}
      </div>
      <MobileBottomNav nav={nav} data-id="element-611" data-mp="4gnaprbn7v0" />
    </div>;
}